<template>
    <div>
        <Header :schoolMap='schoolMap' ></Header>
        <div class='contents'>
            <Sidebar/>
            <div v-show='loading' class='loading-overlay'>
                <div class='loading-spinner'></div>
                <p class='loading-message'>データを取得中...</p>
            </div>
            <router-view v-show='!loading' :schoolMap='schoolMap' :selectSchoolId='selectSchoolId' :selectYearId='selectYearId' :selectEvent='selectEvent'/>
        </div>
    </div>
</template>

<script>

import Header from '@/components/photographer/Header.vue'
import Sidebar from '@/components/photographer/Sidebar.vue'

export default {
    name: 'PhotoGrapher',
    components: {
        Header,
        Sidebar
    },
    data () {
        return {
            schoolMap: {0: {name: '未取得', years: {0: {name: '未取得', events: [{name: '未取得'}]}}}},
            selectSchoolId: 0,
            selectYearId: 0,
            selectEventId: 0,
            selectEvent: { setting: {}, face_recognition: true },
            id: null,
            requestParams: '',
            loading: false,
            settingLoaded: false,
            photosLoaded: false,
            settingRequestId: 0,
            setPhotoGrapherDataHandler: null,
            startLoadingHandler: null,
            photosLoadedHandler: null,
            getSettingHandler: null
        }
    },
    created () {
        try {
            const self = this

            if (self.$route.query.id) {
                self.id = self.$route.query.id
                self.requestParams = `?id=${self.id}`
            }

            this.setPhotoGrapherDataHandler = (params) => {
                self[params.name] = params.value
            }
            this.$root.$on('setPhotoGrapherData', this.setPhotoGrapherDataHandler)

            this.startLoadingHandler = () => {
                self.loading = true
                self.settingLoaded = false
                self.photosLoaded = false
            }
            this.$root.$on('startLoading', this.startLoadingHandler)

            this.photosLoadedHandler = () => {
                self.photosLoaded = true
                if (self.settingLoaded) self.loading = false
            }
            this.$root.$on('photosLoaded', this.photosLoadedHandler)

            this.axios.get(`${process.env.API_URL}/photographer/schools${self.requestParams}`).then((res) => {
                if (res.data.schoolMap && Object.keys(res.data.schoolMap).length) {
                    self.schoolMap = res.data.schoolMap
                }
            }).catch((e) => {
                if (e.response && e.response.status === 401) {
                    self.$root.$emit('notification', 'is-danger', '権限がありません')
                    self.$router.push('/login')
                } else {
                    self.$root.$emit('notification', 'is-danger', 'データの取得に失敗しました')
                }
            })

            this.getSettingHandler = () => {
                let id = self.id || null
                const eventId = self.selectEventId
                const requestId = ++self.settingRequestId
                const isCurrentRequest = () => {
                    return requestId === self.settingRequestId && String(eventId) === String(self.selectEventId)
                }

                if (!eventId) {
                    self.$root.$emit('notification', 'is-primary', '左メニューの学校管理より学校、年度、行事を登録してください')
                    if (isCurrentRequest()) {
                        self.settingLoaded = true
                        self.loading = false
                    }
                    return
                }

                self.axios.get(`${process.env.API_URL}/photographer/event/setting?id=${id}&eventId=${eventId}`).then((res) => {
                    if (!isCurrentRequest() || String(res.data.event.id) !== String(eventId)) return

                    self.selectEvent = res.data.event
                    self.$set(self.selectEvent, 'cardFee', res.data.cardFee)
                    self.$set(self.selectEvent, 'conveniFee', res.data.conveniFee)
                    self.$set(self.selectEvent, 'yuuPacketFee', res.data.yuuPacketFee)
                }).catch((e) => {
                    if (!isCurrentRequest()) return

                    if (e.response && e.response.status === 401) {
                        self.$root.$emit('notification', 'is-danger', '権限がありません')
                        self.$router.push('/login')
                    } else {
                        self.$root.$emit('notification', 'is-danger', 'データの取得に失敗しました')
                    }
                }).finally(() => {
                    if (!isCurrentRequest()) return

                    self.settingLoaded = true
                    self.loading = false
                })
            }
            this.$root.$on('getSetting', this.getSettingHandler)
        } catch (e) {
            this.$root.$emit('notification', 'is-danger', '予期せぬエラーが発生しました')
        }
    },
    beforeDestroy () {
        if (this.setPhotoGrapherDataHandler) this.$root.$off('setPhotoGrapherData', this.setPhotoGrapherDataHandler)
        if (this.startLoadingHandler) this.$root.$off('startLoading', this.startLoadingHandler)
        if (this.photosLoadedHandler) this.$root.$off('photosLoaded', this.photosLoadedHandler)
        if (this.getSettingHandler) this.$root.$off('getSetting', this.getSettingHandler)
        this.settingRequestId++
    },
    methods: {
    }
}
</script>

<style scoped>

.contents {
    display: flex;
}

.main {
    padding-bottom: 20px;
}

.loading-overlay {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    min-height: 400px;
}

.loading-spinner {
    width: 40px;
    height: 40px;
    border: 4px solid #e0e0e0;
    border-top-color: #4a90d9;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
}

@keyframes spin {
    to { transform: rotate(360deg); }
}

.loading-message {
    margin-top: 16px;
    color: #666;
    font-size: 14px;
}

</style>



// WEBPACK FOOTER //
// src/routes/PhotoGrapher.vue